export default __webpack_public_path__ + "static/media/ods8.31ee9b67.svg";